import { NgModule } from '@angular/core';

import { ErrorsModule }   from './errors/errors.module';

@NgModule({
  imports: [
    ErrorsModule,
  ]
})
export class CoreModule {}
